"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const react_transition_group_1 = require("react-transition-group");
const _1 = require("./");
const eventManager_1 = __importDefault(require("./eventManager"));
const override_1 = __importDefault(require("../../lib/helpers/override"));
const MODAL_ID = "modal";
function ModalProvider(props) {
    const [isAllow, setAllow] = (0, react_1.useState)(true);
    const [isActive, setActive] = (0, react_1.useState)(true);
    const [isActiveContainer, setActiveContainer] = (0, react_1.useState)(true);
    const [modal, setModal] = (0, react_1.useState)(null);
    const DOM_MOUNTED = (0, react_1.useRef)(false);
    const modalRef = (0, react_1.useRef)(null);
    // detect click outside and force close modal
    const handleClickOutside = (0, react_1.useCallback)((event) => {
        const target = event.target;
        if (isAllow &&
            modalRef &&
            modalRef.current &&
            !modalRef.current.contains(target) &&
            modal?.options?.close?.outsideClick) {
            if (modal.options &&
                modal.options.close &&
                modal.options.close.preventOutsideClick &&
                typeof modal?.options?.close?.preventOutsideClick === "function") {
                modal.options.close.preventOutsideClick();
            }
            else {
                setActiveContainer(false);
                if (modal?.options?.close?.onClose)
                    modal.options.close.onClose();
            }
        }
    }, [isAllow, modal]);
    /*
        detect keystroke and if it is and ESCAPE, close the modal
     */
    const closeOnEscape = (0, react_1.useCallback)((event) => {
        // const target = event.target as HTMLDivElement;
        if (event.code === "Escape" &&
            isAllow &&
            isActive &&
            modal?.options?.close?.closeOnEscape) {
            setActiveContainer(false);
            if (modal?.options?.close?.onClose)
                modal.options.close.onClose();
        }
    }, [isAllow, modal]);
    (0, react_1.useEffect)(() => {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keyup", closeOnEscape);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keyup", closeOnEscape);
        };
    }, [handleClickOutside, closeOnEscape]);
    /** create <div#MODAL_ID> when not available */
    (0, react_1.useEffect)(() => {
        let containerDomNode = document.getElementById(MODAL_ID);
        if (!containerDomNode) {
            containerDomNode = document.createElement("div");
            containerDomNode.setAttribute("id", MODAL_ID);
            document.body.appendChild(containerDomNode);
        }
        DOM_MOUNTED.current = true;
        return () => {
            DOM_MOUNTED.current = false;
        };
    }, []);
    /** handle all event */
    (0, react_1.useEffect)(() => {
        eventManager_1.default
            .on(_1.Event.Show, (content, options = {}) => {
            if (isAllow) {
                setModal((prev) => {
                    const newOptions = {
                        ...(prev?.options || {}),
                        ...(0, override_1.default)(props.options, options),
                    };
                    return {
                        content,
                        options: {
                            ...newOptions,
                            close: {
                                ...newOptions.close,
                                onClose: options.close?.onClose,
                            },
                        },
                    };
                });
                setAllow(false);
                setActive(true);
            }
        })
            .on(_1.Event.Hide, () => {
            if (isAllow) {
                setActiveContainer(false);
                setAllow(false);
                setModal((prev) => ({
                    ...prev,
                    options: {
                        ...(prev?.options || {}),
                        close: {
                            ...(prev?.options?.close || {}),
                            onClose: undefined,
                        },
                    },
                }));
            }
            if (!!modal?.options?.close?.onClose) {
                modal.options.close.onClose();
            }
        })
            .emit(_1.Event.DidMount);
        return () => {
            eventManager_1.default.off(_1.Event.Show).emit(_1.Event.WillUnmount);
        };
    }, [modal?.options, props.options, isAllow]);
    (0, react_1.useEffect)(() => {
        if (isActive) {
            document.querySelector("body").classList.add("modal-open");
        }
        return () => {
            document.querySelector("body").classList.remove("modal-open");
        };
    }, [isActive]);
    if (document.getElementById(MODAL_ID) && DOM_MOUNTED.current)
        return react_dom_1.default.createPortal((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { timeout: modal?.options?.overlay?.timeout || 250, in: isActive, appear: isActive, unmountOnExit: true, onEntered: () => {
                // setAllow(true);
                setActiveContainer(true);
            }, onExited: () => {
                setAllow(true);
                setActiveContainer(false);
                setModal(null);
            }, classNames: modal?.options?.overlay?.animatedClassNames ?? {
                appear: "opacity-0",
                appearActive: "opacity-0",
                appearDone: "opacity-100",
                enter: "opacity-0",
                enterActive: "opacity-0",
                enterDone: "opacity-100",
                exit: "",
                exitActive: "opacity-0",
                exitDone: "opacity-0",
            }, children: (0, jsx_runtime_1.jsx)("div", { className: [
                    modal?.options?.overlay?.className,
                    modal?.options?.overlay?.overrideClassName,
                ].join(" "), style: modal?.options?.overlay?.style, children: (0, jsx_runtime_1.jsx)("div", { className: [
                        modal?.options?.container?.className,
                        modal?.options?.container?.overrideClassName,
                    ].join(" "), style: modal?.options?.container?.style, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { timeout: modal?.options?.wrapper?.timeout || 250, in: isActiveContainer, appear: isActiveContainer, unmountOnExit: true, onEntered: () => {
                            setAllow(true);
                        }, onExited: () => {
                            setAllow(true);
                            setActive(false);
                        }, classNames: modal?.options?.wrapper?.animatedClassNames ?? {
                            appear: "opacity-0",
                            appearActive: "opacity-0",
                            appearDone: "opacity-100",
                            enter: "opacity-0",
                            enterActive: "opacity-0",
                            enterDone: "opacity-100",
                            exit: "",
                            exitActive: "opacity-0",
                            exitDone: "opacity-0",
                        }, children: (0, jsx_runtime_1.jsxs)("div", { ref: modalRef, className: [
                                modal?.options?.wrapper?.className,
                                modal?.options?.wrapper?.overrideClassName,
                            ].join(" "), style: modal?.options?.wrapper?.style, children: [!!modal?.options?.close?.display && ((0, jsx_runtime_1.jsx)("button", { className: [
                                        modal?.options?.close?.className ||
                                            "absolute right-0 top-0 w-8 h-8 flex items-center justify-center",
                                    ].join(" "), onClick: () => {
                                        setActiveContainer(false);
                                        if (modal?.options?.close?.onClose)
                                            modal.options.close.onClose();
                                    }, children: modal?.options?.close?.icon ?? (0, jsx_runtime_1.jsx)("span", { children: "\u00D7" }) })), modal?.content] }) }) }) }) }), document.getElementById(MODAL_ID));
    return null;
}
exports.default = ModalProvider;
